<template>
  <BaseFetchData :action="loadData" v-slot="fetchDataProps">
    <div v-if="fetchDataProps.status.resolved" class="space-y-8">
      <div>
        <AccProductReactionCreateAction
          :contact-id="contactId"
          :acc-product-reaction-type-options="accProductReactionOptions"
          @create="refreshList"
        />
      </div>
      <div>
        <AccProductReactionList ref="accProductReactionList" :contact-id="contactId" />
      </div>
    </div>
  </BaseFetchData>
</template>

<script>
import { accProductReactionTypesClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import AccProductReactionCreateAction from './AccProductReactionCreateAction.vue';
import AccProductReactionList from './AccProductReactionList.vue';

export default {
  components: { AccProductReactionList, AccProductReactionCreateAction },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      accProductReactionTypes: [],
    };
  },
  computed: {
    accProductReactionOptions() {
      return this.accProductReactionTypes.map((accProductReactionType) => ({
        label: accProductReactionType.name,
        value: accProductReactionType.id,
      }));
    },
  },
  methods: {
    async loadData() {
      try {
        const response = await accProductReactionTypesClient.list();

        this.accProductReactionTypes = response.data.map(mapKeysToCamelCase);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    refreshList() {
      this.$emit('refresh');
      this.$refs.accProductReactionList.refreshList();
    },
  },
};
</script>
